import React from "react"

const TertiaryHeading = ({ children, style = {} }) => (
    <h3 style={style}>
      {children}
    </h3>
)

export default TertiaryHeading
